import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Routes a visitor opens (the public tour, the org page, every embed). They
 * keep the visitor look, so they never get the tool's kit.
 */
export function isVisitorRoute(pathname: string, embed: boolean): boolean {
  return embed || /^\/(t|o)\//.test(pathname);
}

/**
 * Turns the new kit (`styles/kit-next.css`) on for the tool routes and off for
 * the visitor ones. It lives on <html>, not on a page root, because menus,
 * dialogs, tooltips and toasts are portaled to <body> and must follow it.
 * Set in a layout effect so the first paint of a route already has it.
 */
export function useKitScope(embed: boolean) {
  const { pathname } = useLocation();
  const tool = !isVisitorRoute(pathname, embed);
  useLayoutEffect(() => {
    const root = document.documentElement;
    if (tool) root.dataset.kit = 'next';
    else delete root.dataset.kit;
  }, [tool]);
}
